import { render, staticRenderFns } from "./ModalUpdateCampaignPageName.vue?vue&type=template&id=07d28117&scoped=true&"
import script from "./ModalUpdateCampaignPageName.vue?vue&type=script&lang=js&"
export * from "./ModalUpdateCampaignPageName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d28117",
  null
  
)

export default component.exports